import type FeedbackItemType from '@interfaces/FeedbackItem';
import classNames from 'classnames';
import type {ChangeEvent, ReactElement} from 'react';

interface Props extends FeedbackItemType {
    name: string;
    onChange(event: ChangeEvent): void;
}

export default function FeedbackItem(props: Props): ReactElement {
    const className = classNames({
        feedback__item: !props.isShort,
        'feedback__item--short': props.isShort,
        error: props.isError,
    });

    if (props.isBig) {
        return (
            <textarea
                name={props.name}
                className={className}
                placeholder={props.title}
                onChange={props.onChange}
            />
        );
    }

    return (
        <input
            name={props.name}
            type="text"
            className={className}
            placeholder={props.title}
            onChange={props.onChange}
        />
    );
}
